import markdownit from 'markdown-it';

const converter = markdownit({ breaks: true });

export const convertMarkdown = (text: string, inline = false): string => {
  return inline ? converter.renderInline(text) : converter.render(text);
};
